<template>
  <div id="toppage" ref="toppage">
    <!-- breadcrumb start-->
    <section class="breadcrumb breadcrumb_bg">
      <v-container class="container">
        <v-layout row class="row">
          <v-flex lg12>
            <div class="breadcrumb_iner">
              <div class="breadcrumb_iner_item">
                <h2 v-if="getLang() == 'id'" v-html="banner.slogan.id"></h2>
                <h2 v-else v-html="banner.slogan.en"></h2>
                <Ubie :key="ubieID"/>
              </div>
              <div class="breadcrumb_iner_item text-left">
                <img class="w-300x" :src="banner.img" :alt="banner.alt">
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- breadcrumb start-->

    <!-- ads part start-->
    <section class="pt-10 pb-40" v-show="false">
      <v-container class="container">
        <v-layout row>
          <v-flex md12>
            <div class="text-center">
              
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- ads part end-->

    <!-- about part start-->
    <section class="about_part pt-10 pb-40">
      <v-container class="container">
        <v-layout row>
          <v-flex md12>
            <div class="about_text pr-90 pr-xs-0">
              <div class="experiance">
                <h4>Daniel Wai Diabetes,<br />Thyroid And Hormone Clinic Pte. Ltd.</h4>
              </div>
              <h4 class="mt-40 mb-0 mt-xs-0" v-if="getLang() == 'id'" v-html="about.subheader.id"></h4>
              <h4 class="mt-40 mb-0 mt-xs-0" v-else v-html="about.subheader.en"></h4>
              <p class="mt-10" v-if="getLang() == 'id'" v-html="about.desc.id"></p>
              <p class="mt-10" v-else v-html="about.desc.en"></p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- about part end-->

    <!-- services part start-->
    <section id="profile" class="service_part section_padding">
       <v-container class="container">
        <v-layout row>
          <v-flex md12>
            <v-layout wrap class="single_service_part" style="background:none;">
              <v-flex v-for="(item, i) in services" :key="i" sm12>
                <v-flex class="single_service_part active m-10 m-xs-0 mb-xs-10">
                  <div class="single_service_text text-left m-5 p-0 pl-50 pl-xs-0">
                    <div class="text-center h-100" style="display:table-cell;vertical-align: top;">
                      <span v-html="gettwodigit(i+1)+'.'" class="color-facebook" style="background:none;font-size:3em;"></span>
                    </div>
                    <div class="p-0 m-5" style="display:table-cell;vertical-align: bottom;">
                      <h2 v-html="item.main" class="pl-30 m-5 pl-xs-0"></h2>
                      <ul class="unordered-list ml-50 ml-xs-0">
                        <li v-for="(sub, j) in item.subs" :key="j" class="w-100">
                          <p v-html="sub"></p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- services part end-->
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from "vuex";
  import Ubie from '../components/ubie'

  export default {
    props: {
      language: String
    },
    data () {
      return {
        ubieID: 4,
        banner: {
          img: require('@/assets/img/daniel_side.png'),
          alt: 'Dr. Daniel Wai',
          slogan: {
            en: 'Our Services',
            id: 'Jasa Pelayanan Kami'
          }
        },
        about: {
          header: 'Daniel Wai Diabetes,<br />Thyroid And Hormone Clinic Pte. Ltd.',
          subheader: {
            en: 'Balance in the endocrine or hormone system is essential to our health.',
            id: 'Keseimbangan di endokrin dan sistem hormon ditubuh adalah sangat penting untuk kesehatan kita.'
          },
          desc: {
            en: 'Diseases occur when this balance is lost. We are committed to restore the body\'s nature balance for our patients.',
            id: 'Sakit penyakit bisa terjadi ketika keseimbangan sistem hormon ditubuh kita hilang. Kita berkomitmen untuk memulihkan keseimbangan natural tubuh untuk para pasien kita.'
          },
        },
        services:[
          {
            icon: '',
            bg: 'background: red;',
            main: 'Diabetes Mellitus',
            subs: [
              'Management of type 1, type 2 and gestational diabetes',
              'On site capillary glucose and Hba1c testing'
            ]
          },
          {
            icon: '',
            bg: 'background: blue;',
            main: 'Thyroid Diseases',
            subs: [
              'Management of hyperthyroidism, hypothyroidism, thyroiditis, thyroid nodules',
              'On site ultrasound of thyroid gland',
              'UItrasound guided fine needle aspiration biopsy of thyroid nodules',
            ]
          },
          {
            icon: '',
            bg: 'background: yellow;',
            main: 'Cholesterol Disorders',
            subs: [
              'Management of hypercholesterolemia, dyslipidemia and severe hypertriglyceridemia',
              'Difficult cases with allergy or side effects (e.g. muscle ache) from medications',
            ]
          },
          {
            icon: '',
            bg: 'background: green;',
            main: 'Hypertension',
            subs: [
              'Difficult to treat hypertension',
              'Hypertension in young people (usually with reversible cause)',
            ]
          },
          {
            icon: '',
            bg: 'background: pink;',
            main: 'Obesity And Metabolic Diseases',
            subs: [
              'Management of fatty liver with raised liver enzymes, polycystic ovaries',
              'On site height, weight and body fat analysis',
              'Medical support for patients undergoing bariatric surgery',
            ]
          },
          {
            icon: '',
            bg: 'background: purple;',
            main: 'Calcium And Osteoporosis',
            subs: [
              'Management of hypercalcemia, hypocalcemia, osteoporosis, vitamin D deficiency',
            ]
          },
          {
            icon: '',
            bg: 'background: purple;',
            main: 'Pituitary Disorders',
            subs: [
              'Management of pituitary hormone excess or deficiency',
              'Medical support for patients undergoing pituitary surgery',
            ]
          },
          {
            icon: '',
            bg: 'background: purple;',
            main: 'Adrenal Disorders',
            subs: [
              'Management of adrenal hormone excess or deficiency',
              'Medical support for patients undergoing adrenal surgery',
            ]
          },
          {
            icon: '',
            bg: 'background: purple;',
            main: 'Sex Hormone Disorders',
            subs: [
              'Management of testosterone and estrogen excess and deficiency',
            ]
          }
        ],
      }
    },
    components: {
      Ubie
    },
    methods: {
      getLang() {
        this.language = this.$cookies.get('whatlang');
        return this.language;
      },
      gettwodigit(n) {
        return n > 9 ? "" + n: "0" + n;
      },
      ...mapActions([]),
      ...mapMutations(['set_vsnackbar_Show', 'set_vsnackbar_Msg']),
    },
    computed: {
      ...mapState({
      })
    },
    watch: {
    },
    mounted() {
      if (localStorage.getItem('reloaded')) {
        // The page was just reloaded. Clear the value from local storage
        // so that it will reload the next time this page is visited.
        localStorage.removeItem('reloaded');
        this.ubieID = 4;
      } else {
          // Set a flag so that we know not to reload the page twice.
          localStorage.setItem('reloaded', '1');
          location.reload();
          this.ubieID += 2;
          // this.$forceUpdate();
      }
    },
  }
</script>

<style>
</style>